import * as types from './types';

export const getTimeTypesRequest = (data) => ({ type: types.GET_TIME_TYPES_REQUEST, data });
export const getTimeTypesRequestFailure = (error) => ({ type: types.GET_TIME_TYPES_REQUEST_FAILURE, error });
export const getTimeTypesRequestSuccess = (data) => ({ type: types.GET_TIME_TYPES_REQUEST_SUCCESS, data });
